import type { Region } from './config/region-config'

const NODE_RUNTIME = Reflect.get(globalThis, 'process') as {
  env?: Record<string, string | undefined>
} | undefined
const RUNTIME_ENV = import.meta.env || NODE_RUNTIME?.env || {}

const DEFAULT_POSTHOG_HOST = 'https://i.spatialwalk.ai/'
export const POSTHOG_HOST = (RUNTIME_ENV.VITE_POSTHOG_HOST || '').trim() || DEFAULT_POSTHOG_HOST
// Keep Toolbar UI/auth requests on PostHog while analytics ingestion uses our first-party proxy.
export const POSTHOG_UI_HOST = 'https://us.posthog.com'
// PostHog public Project token，从部署环境读取，不在源码中绑定具体 Project。
export const POSTHOG_API_KEY = (RUNTIME_ENV.VITE_POSTHOG_API_KEY || '').trim()
export const POSTHOG_TRACK_EVENTS = RUNTIME_ENV.VITE_POSTHOG_TRACK_EVENTS !== 'false' // 默认开启
export const POSTHOG_PROJECT_NAME = RUNTIME_ENV.VITE_POSTHOG_PROJECT_NAME?.trim()
// GA4 Measurement ID（G-XXXXXXXXXX），只在 VITE_ENV=production 时生效。
export const GA4_MEASUREMENT_ID = RUNTIME_ENV.VITE_GA4_MEASUREMENT_ID || ''

const SITE_ENVIRONMENT = import.meta.env?.VITE_ENV || (import.meta.env?.DEV ? 'development' : 'production')
export const ENV_TEST = SITE_ENVIRONMENT !== 'production'

/**
 * 获取区域配置
 * 通过环境变量 VITE_REGION 控制，支持 'us' | 'cn' | 'test'
 * 'test' 仅在 ENV_TEST 为 true 时有效
 * 如果未设置或无效，默认返回 'us'
 */
export function getRegionFromHostname(): Region {
  const envRegion = import.meta.env.VITE_REGION
  const validRegions: Region[] = ENV_TEST ? ['us', 'cn', 'test'] : ['us', 'cn']
  if (envRegion && validRegions.includes(envRegion as Region)) {
    return envRegion as Region
  }
  // Default to 'us' if not set or invalid
  return 'us'
}

type WebListName = 'playground' | undefined

/**
 * 根据环境变量获取列表名称
 * 仅通过环境变量 VITE_WEB_LIST_NAME 控制
 * 仅支持 'playground'，如果未设置或不是 'playground'，返回 undefined
 */
export function getWebListName(): WebListName {
  const envListName = import.meta.env.VITE_WEB_LIST_NAME
  if (envListName === 'playground') {
    return 'playground'
  }

  return undefined
}

/**
 * Check if URL has debug=1 parameter
 */
function hasDebugParam(): boolean {
  if (typeof window === 'undefined') {
    return false
  }
  const params = new URLSearchParams(window.location.search)
  return params.get('debug') === '1'
}

/**
 * Comprehensive debug mode check
 * Returns true if:
 * - VITE_ENV is not `production`, OR
 * - URL has debug=1 parameter
 */
export function isDebugMode(): boolean {
  return ENV_TEST || hasDebugParam()
}

/**
 * 正式环境的音色选项
 */
export const PROD_VOICES = [
  { value: '6ccbfb76-1fc6-48f7-b71d-91ac6298247b', label: '女性' },
  { value: 'c961b81c-a935-4c17-bfb3-ba2239de8c2f', label: '男性' },
] as const
